import isEmpty from "lodash-es/isEmpty";
import { isModuleReady } from "~/composables/general";
import { authPages } from "~/constants/navigation";
import { useSessionStore } from "~/stores/session";

export default defineNuxtRouteMiddleware(async (to, _from) => {
  const nuxtApp = useNuxtApp();
  const sessionStore = useSessionStore(nuxtApp.$pinia);
  if (import.meta.server) return;
  await isModuleReady(sessionStore);
  if (!sessionStore.isLoggedIn) {
    const { syncAzureAuth } = useAuth();
    await syncAzureAuth();
  }
  if (sessionStore.isLoggedIn) {
    console.log("proceed", to.name);
    if (isEmpty(sessionStore.userData?.company) && to.name !== "setup")
      return navigateTo("/setup");
    if (authPages.includes(to.name as string)) return navigateTo("/");
    return;
  }
  if (authPages.includes(to.name as string)) return;
  if (!sessionStore.isLoggedIn) return navigateTo("/login");
});
